import './issuers.scss'

import { Empty, Skeleton, Table, Typography } from 'antd'
import React, { useState } from 'react'
import { Column } from 'react-display-flex'
import useSWR from 'swr'

import { fetcher } from '../../../../api'
import { BankingGroup, BankingGroupTableItem } from '../models'
import { UpdateBankingGroupRatingDrawer } from '../UpdateBankingGroupRating/UpdateBankingGroupRatingDrawer'
import { buildBankingGroupColumns } from './banking-group-table-columns'

export const BankingGroups = () => {
  const [updateBankingGroupRating, setUpdateBankingGroupRating] = useState(null)

  const { data: bankingGroups, error, mutate } = useSWR('/banking-groups', fetcher)

  const columns = buildBankingGroupColumns({ onUpdate: setUpdateBankingGroupRating })

  const tableItems = transformBankingGroupsToTableItems(bankingGroups)

  const onCloseDialogs = () => {
    setUpdateBankingGroupRating(null)
  }

  const onSuccess = () => {
    onCloseDialogs()
    mutate()
  }

  if (error) {
    return (
      <Empty description="Something wrong happen">
        {error?.error_message || error?.message || 'We have an error retrieving banking groups'}
      </Empty>
    )
  }

  return (
    <Column className="issuers">
      <Typography.Title>Banking Group Ratings</Typography.Title>

      {!error && !bankingGroups ? (
        <Skeleton />
      ) : (
        <Table
          dataSource={tableItems}
          loading={!bankingGroups}
          columns={columns}
          pagination={false}
          rowKey="id"
          size="small"
        />
      )}

      <UpdateBankingGroupRatingDrawer
        group={updateBankingGroupRating}
        isVisible={updateBankingGroupRating}
        onClose={onCloseDialogs}
        onSuccess={onSuccess}
      />
    </Column>
  )
}

const transformBankingGroupsToTableItems = (bankingGroups?: BankingGroup[]): BankingGroupTableItem[] =>
  bankingGroups?.map((bankingGroup) => ({ ...bankingGroup, issuersCount: bankingGroup?.issuers.length })) || []
